import Image from 'next/image';

import styles from './social-network.module.scss';

const SocialNetwork = ({ data }) => {
  const renderStore = (item, index) => (
    <li
      key={index}
      className={styles.item}
      itemScope
      itemType='https://schema.org/Organization'
    >
      <a
        title={item?.link}
        href={item?.link}
        target='_blank'
        rel='nofollow noopener noreferrer'
      >
        <Image
          src={item?.icon}
          className={styles.icon}
          width={24}
          height={24}
          alt={'social network icons'}
          title={'Social Network Icons'}
          loading='lazy'
        />
      </a>
    </li>
  );
  return (
    <ul
      className={styles.list}
      itemScope
      itemType='https://schema.org/ItemList'
    >
      {data?.map(renderStore)}
    </ul>
  );
};

export default SocialNetwork;
